import { render } from "./PatientConnectTwo.vue?vue&type=template&id=646d9520"
import script from "./PatientConnectTwo.vue?vue&type=script&lang=js"
export * from "./PatientConnectTwo.vue?vue&type=script&lang=js"

import "./PatientConnectTwo.vue?vue&type=style&index=0&id=646d9520&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__